// extracted by mini-css-extract-plugin
module.exports = {"popupContainer":"_3VAH9Yz","textContainer":"DkqY3sG","buttonContainer":"k2iqvAF","popup":"_2B0xf3d","loadingSpinnerContainer":"_39k8Izt"};